const lightColors = [
  "#fff6a0", "#d7d9fe", "#ffd8fb", "#d2f7df", "#fedcd1", // Predefined light colors
  "#ffebcd", "#e1f7d5", "#f0f8ff", "#fafad2", "#f5fffa", // More light colors
  "#f1e4e4", "#e3f8f1", "#ffccff", "#d8e8ff", "#fff0f5", // Additional light colors
  "#fffacd", "#ffeb99", "#f7f7f7", "#f0e6f6", "#f1ffe7", // More pastel-like light colors
  "#d9f2f2", "#ffe4e1", "#e6e6fa", "#b2f7b2", "#f1faff", // Soft pastel tones
  "#f3d1d1", "#b6f3d1", "#e4e7ff", "#ffe4b5", "#ffebf0"  // Additional soft colors
];

// Function to randomly select a color from the array and apply it to the list items
function applyRandomColors() {
  const items = document.querySelectorAll('.product-text-list-item');  // Get all items
  items.forEach(item => {
    const randomColor = lightColors[Math.floor(Math.random() * lightColors.length)]; // Get random color
    item.style.backgroundColor = randomColor; // Apply the random color
  });
}

// Call the function to apply random colors to the items
applyRandomColors();